// TODO - this should be spread in to the ThemeProvider as custom tokens - https://qbe-appservices.atlassian.net/browse/AD1-579

export const Z_INDEX = {
  // Move behind layout, header and footer
  APP_BACKGROUND: -1,
  APP_FLOATING_TEXT: 1,
  APP_FOOTER: 2,
};
